export default "./dist/stdassets/images/icons/select-centre.png";